import { Flex, Skeleton } from 'antd';
import { useGetClientOrderCargoes } from 'client-app/api/client-cargoes/use-get-client-order-cargoes';
import { CargoItem } from '../cargo-item';
import styles from './cargo-list.module.scss';
import type { ICargoListProps } from './types';

export const CargoList: React.FC<ICargoListProps> = (props) => {
  const { orderId } = props;
  const { data: orderCargoes, isLoading: isOrderCargoesLoading } = useGetClientOrderCargoes(orderId);

  return (
    <Flex gap={16} className={styles.list} vertical>
      {isOrderCargoesLoading ? <Skeleton /> : orderCargoes?.map((cargo) => <CargoItem key={cargo.id} cargo={cargo} />)}
    </Flex>
  );
};
